// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__3XF8j","icon":"styles_icon__Y3gSp","secondaryIcon":"styles_secondaryIcon__1_FHz","value":"styles_value__fB0LV","secondary":"styles_secondary__2Uu9u"};